<template>
  <div class="selection" :class="bg_color">
    <div class="title-with-see-more content-container">
      <div class="header-vertical-line">
        <div class="flex-col">
          <h4>{{ title_first }}</h4>
          <h4>{{ title_second }}</h4>
        </div>
      </div>
      <div @click="visitPage" class="link arrow">
        {{ "landing_page.titles.see_more" | translate }}
      </div>
    </div>
    <div class="product-row-container content-container breakout">
      <div class="product-row">
        <product-card
          v-for="(product, j) in selection"
          :key="j"
          :product="product"
          @card-clicked="visitProductPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { applyFilter } from "../../services/api";
import ProductCard from "../molecules/product-card";
export default {
  name: "product-row",
  components: {
    ProductCard
  },
  props: {
    title_first: String,
    title_second: String,
    see_more_link: String,
    filter: Object,
    bg_color: String,
    sex: String
  },
  data() {
    return {
      selection: []
    };
  },
  methods: {
    visitPage() {
      this.$router.push({
        name: "Overview",
        params: {
          sex: this.sex
        }
      });
    },
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    },
    async getSelection() {
      const response = await applyFilter({ numberOfItems: 20, ...this.filter });
      if (response.status === 201) {
        this.selection = response.data;
      } else {
        this.handleHttpError(response);
      }
    }
  },
  created() {
    this.getSelection();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.selection {
  padding: $m-s 0;

  .product-row-container {
    overflow-x: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .product-row {
    display: flex;
    flex-direction: row;
  }
}
</style>
<style lang="scss">
@import "~@/styles/global.scss";
.product-row {
  .product-card {
    width: 12rem;
    min-width: 12rem;

    @media (min-width: $breakpoint-md) {
      width: 15rem;
      min-width: 15rem;
    }
  }
}
</style>
